module.exports = "//public.zight.com/packs/media/images/onboarding/apple-7a0bd32233be3c0c57802e918c4b06af.svg";